import { Stack } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import TextField from 'domains/core/components/TextField';
import EmojiPicker from '../EmojiPicker';
import MergeTagPicker from '../MergeTagPicker';

type Props = {
    isContentLoading: boolean;
    label?: string;
    message: string;
    rows?: number;
    setMessage: (message: string) => void;
    width?: string;
};

const SmsMessageInput = ({ isContentLoading, label = '', message, rows, setMessage, width }: Props) => {
    const [cursorPosition, setCursorPosition] = useState({ start: 0, end: 0 });
    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.selectionStart = cursorPosition;
            inputRef.current.selectionEnd = cursorPosition;
        }
    }, [cursorPosition]);

    const handleContentFieldChange = (e: any) => {
        setMessage(e.target.value);
    };

    const insertValueIntoMessage = (value?: string) => {
        const newContent = message.substring(0, cursorPosition.start) + value + message.substring(cursorPosition.end);
        setMessage(newContent);
        inputRef.current.focus();
    };

    return (
        <Stack maxWidth="800px">
            <TextField
                counterCurrent={message?.length}
                counterMax={1600}
                disabled={isContentLoading}
                inputProps={{ maxLength: 1600, 'data-testid': 'content-field' }}
                inputRef={inputRef}
                label={label}
                multiline
                onBlur={(e) => {
                    setCursorPosition({ start: e.target.selectionStart || 0, end: e.target.selectionEnd || 0 });
                }}
                onChange={handleContentFieldChange}
                placeholder="Enter your message here"
                rows={rows ?? 9}
                value={message}
                width={width ?? '100%'}
                withCounter
            />
            <Stack direction="row">
                <EmojiPicker handleSelect={insertValueIntoMessage} />
                <MergeTagPicker handleSelect={insertValueIntoMessage} />
            </Stack>
        </Stack>
    );
};

export default SmsMessageInput;
